import { styled, css } from '@mui/material';
import { Container } from '../../common';
import { MIN_WIDTH_MD } from '../../../theme/breakpoints';

export const StyledPaymentNotificationContainer = styled(Container)`
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

export const StyledFixedContainer = styled('div')(
  ({ theme, fixed }) => css`
    position: relative;

    ${fixed
      ? css`
          position: fixed;
          top: ${theme.shape.headerMobile};
          margin-top: 1px;
          left: 50%;
          width: 100%;
          transform: translateX(-50%);
          z-index: 2;

          & > div {
            margin: 0 1rem;
          }

          @media (min-width: ${MIN_WIDTH_MD}) {
            width: ${theme.shape.container};

            & > div {
              margin: 0;
            }
          }
        `
      : ''}
  `
);

export const StyledPayNowLinkContainer = styled('div')(
  ({ textAlign }) => css`
    margin-top: 0.25rem;
    text-align: ${textAlign || 'right'};
  `
);
